import getQueryList from './getQueryList';

export default function checkIsPriceShownInQuery(priceReference, query = {}) {
  if (!priceReference || !query?.show_prices) return false;

  return getQueryList(query.show_prices).includes(priceReference);
}
